<div class="welcomeWrapper">
  <h2 class="loginHeading">Please click Sign-in to login into RPS Configuration Portal</h2>
  <button class="button" (click)="signIn()"> Sign in </button>
</div>
